module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box",
    class: _vm.addBackground
  }, [_c('div', {
    staticClass: "c-header",
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [(_vm.addBackground === '') ? _c('img', {
    attrs: {
      "src": require("./images/header-logo-white-xd.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])]), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _c('div', {
    staticClass: "notice-bg"
  }, [(!_vm.lastNotice.isImage) ? _c('div', {
    staticClass: "new-notice"
  }, [_c('h2', [_vm._v(_vm._s(_vm.lastNotice.title))]), _c('p', {
    staticClass: "update-time"
  }, [_vm._v(_vm._s(_vm.lastNotice.releaseDate) + "(发布时间)")]), _c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lastNotice.content)
    }
  }), _c('span', {
    staticClass: "more-notice",
    on: {
      "click": _vm.goNoticeList
    }
  }, [_vm._v("更多公告>>")])]) : _c('div', {
    staticClass: "new-notice"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require(("./images/" + (_vm.lastNotice.content))),
      "alt": "图片加载失败"
    }
  })]), _c('span', {
    staticClass: "more-notice",
    on: {
      "click": _vm.goNoticeList
    }
  }, [_vm._v("更多公告>>")])]), _c('span', {
    staticClass: "blue-shadow"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15c048f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c048f4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/announcement.vue
// module id = 1185
// module chunks = 2